import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GoalService } from '@EYN/components';
import { Observable } from 'rxjs/internal/Observable';
import { first, map } from 'rxjs/operators';

@Injectable()
export class CanAccessPlanEditGuard implements CanActivate {
	constructor(private goalService: GoalService) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const planId = +route.params.planId;
		return this.goalService.withRouteConfig()
			.pipe(first(), map(([{ overviewRoute }, goal]) => {
				const plan = goal.plans.find(goalPlan => goalPlan.planType === planId);
				if ((!plan && this.goalService.isGoalStarted(goal)) || this.goalService.isPlanStarted(plan)) {
					return true;
				} else {
					this.goalService.goToOverviewPage();
					return false;
				}
			}));
	}
}
